import { checkFetchForError, debounce, parseFetchResponse } from '../../../../node_modules/glo-shared-js/utils/helpers';

// Scroll to load more content logic
(function() {
	if (document.querySelector('.card-grid--scroll')) {
		var pageToLoad = 2;
		var hasLoadedAllContent = false;
		var isLoadingMoreContent = false;

		var loadMoreContent = function() {
			var contentType = 'program';

			if (!isLoadingMoreContent) {
				document.querySelector('.loader__wrapper').classList.remove('hide');
				isLoadingMoreContent = true;

				fetch(`/proxy/v1/loadMoreContent?contentType=${contentType}&pageToLoad=${pageToLoad}`)
					.then(checkFetchForError)
					.then(parseFetchResponse)
					.then(function(response) {
						// If no card html was returned, we're at the end of the page
						if (response.indexOf('div') === -1) {
							hasLoadedAllContent = true;
						} else {
							var cardGrid = document.querySelector('.card-grid');

							++pageToLoad;
							cardGrid.innerHTML = cardGrid.innerHTML + response;
						}

						document.querySelector('.loader__wrapper').classList.add('hide');
						isLoadingMoreContent = false;
					})
					.catch(function() {
						document.querySelector('.loader__wrapper').classList.add('hide');
						isLoadingMoreContent = false;
					});
			}
		};

		window.addEventListener('scroll', debounce(function() {
			var buffer = 100;
			var viewport = document.body.offsetHeight - window.innerHeight - buffer;

			if (viewport < (window.pageYOffset + buffer) && !hasLoadedAllContent) loadMoreContent();
		}, 250));
	}
})();
